import { ExpenseFrequency, ExpensesDTO } from '../../api/useExpensesQuery';

export const FREQUENCY_OPTIONS = [
  { value: ExpenseFrequency.Monthly, label: 'Month' },
  { value: ExpenseFrequency.Yearly, label: 'Year' },
];

export interface FormValues {
  amount: number;
  frequency: ExpenseFrequency;
}

export const dataToForm = (data: ExpensesDTO): FormValues => {
  if (!data.TotalExpenses) {
    return {
      amount: 0,
      frequency: ExpenseFrequency.Monthly,
    };
  }

  return {
    amount: data.TotalExpenses.Amount,
    frequency:
      data.TotalExpenses.Frequency !== null
        ? data.TotalExpenses.Frequency
        : ExpenseFrequency.Monthly,
  };
};
